<template>
  <div>
    <component :is="item.name" v-for="item in pageComponents" :key="item.id" :data="item.componentData" />
    <div v-if="needCopyLink" class="popup-abs">
      <div class="pupup-mask">
        <div ref="copyBtn" class="popup-center" @click="copy()">点击复制链接到剪切板</div>
      </div>
    </div>
    <div v-if="showGuideBrowser" class="popup-abs">
      <div class="pupup-mask">
        <div class="guide-box">
          <img class="guide-img" src="https://datahub.haohuan.com/gfs/2025-10/6222883ebfb122bd78a267cf2de3aa2f.png">
          <p class="guide-text">
            请点击右上角选择<br />
            “在浏览器中打开”
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { post } from '../common/http';
  import { sensorsBuriedPoint, getUrlParam } from '../common/util';

  export default {
    name: "Preview",
    data() {
      return {
        pageConfig: {},
        pageComponents: [],
        paramCode: "",
        timeSpan: 0,
        needCopyLink: 0,
        showGuideBrowser: false,
      }
    },
    created() {
      this.timeSpan = performance.now();
      // const startTime = performance.now();
      // 获取地址栏上的code值
      const params = new URLSearchParams(window.location.search);
      const queryCode = params.get("code");
      const queryPageName = params.get("page_name");
      if (!queryCode) {
        return;
      }
      this.needCopyLink = params.get("needCopyLink");
      // AB测的两个code值
      const [ codeA, codeB ] = queryCode.split('@');
      if (!codeB) {
        // 没有AB测 直接取地址栏上的code
        this.paramCode = codeA;
        // 添加埋点，页面加载到开始请求接口时间
        // const endTime = performance.now();
        // sensorsBuriedPoint('RecordPageViewTime', {
        //   Url: window.location.href,
        //   timeSpan: endTime - startTime,
        //   timeClassify: '页面加载到开始请求接口'
        // }, false);
        this.getPageDetail();
        return
      }
      // AB测 判断localStorage 是不是有缓存
      const formerCode = localStorage.getItem("useCode");
      // 如果有缓存 且 缓存的值是当前地址栏上的值
      if (formerCode && [codeA, codeB].includes(formerCode)) {
        // 直接用缓存里的
        this.paramCode = formerCode;
        this.getPageDetail();
        return;
      }
      // 没有缓存 或者 缓存的值不是当前地址栏上的值
      // random函数，随机50%走A页面，另外50%走B页面
      const randomNum = Math.random();
      const useGroup = randomNum < 0.5 ? 'A分组' : 'B分组';
      this.paramCode = randomNum < 0.5 ? codeA : codeB;
      // console.log('当前随机数', randomNum);
      // 存到localStorage中，下次直接取该页面
      localStorage.setItem("useCode", this.paramCode);
      localStorage.setItem("useGroup", useGroup);
      if (queryPageName) {
        const [ pageNameA, pageNameB ] = queryPageName.split('@');
        const pageName = randomNum < 0.5 ? pageNameA: pageNameB;
        localStorage.setItem("pageName", pageName);
      }
      this.getPageDetail();
    },
    methods: {
      copy() {
        let aux = document.createElement("input");
        aux.setAttribute("value", window.location.href);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        this.needCopyLink = '';
      },
      isES6Supported() {
        try {
          new Function("(a = 0) => a");
          return true;
        } catch (err) {
          return false;
        }
      },
      getPageDetail() {
        try {
          const type = this.$route.name;
          const data = {
            code: this.paramCode,
            type,
          }
          post('/api/landingPage/getTemplate', data).then(res => {
            // sensorsBuriedPoint('RecordPageViewTime', {
            //   Url: window.location.href,
            //   timeSpan: performance.now() - this.timeSpan,
            //   timeClassify: '页面加载到接口请求完成'
            // }, false);
            try {
              // const startTime = performance.now();
              const { config, pageConfig } = res.data;
              if (!config && !pageConfig) {
                // 页面下线后，保留之前逻辑展示空白页面
                return
              }
              this.pageComponents = JSON.parse(config);
              this.pageConfig = JSON.parse(pageConfig);
              // 页面ID存入缓存
              sessionStorage.setItem("pageId", res.data.pageId || res.data.id || "0");
              sessionStorage.setItem("pageName", res.data.pageName || res.data.name || "");
              // 灰度信息存入缓存
              sessionStorage.setItem("grayInfo", JSON.stringify(res.data.grayInfo || []));
              document.title = this.pageConfig.title;
              const sensorObj = {
                title: this.pageConfig.title,
                Url: window.location.href,
                Source: getUrlParam("from") || "",
                userkey: getUrlParam("userKey") || "",
                IsES6Supported: this.isES6Supported(),
                TimeStamp: Date.now()
              }
              const extraSensorObj = {
                LocationPage: this.pageConfig.sensorLocationPage,
              }
              this.pageConfig.sensorNeedFrom && (extraSensorObj[this.pageConfig.sensorNeedFrom] = getUrlParam("from") || "");
              this.pageConfig.sensorName ? sensorsBuriedPoint(this.pageConfig.sensorName, extraSensorObj, false) : sensorsBuriedPoint('PageView', sensorObj, false);
              this.$nextTick(() => {
                let curElement = document.querySelector('body');
                curElement.style.background = this.pageConfig.bgSetting;
                curElement.style.backgroundColor = this.pageConfig.bgColor;
                curElement.style.paddingTop = (this.pageConfig.paddingTop ) / 16 + 'rem';
                curElement.style.paddingBottom = (this.pageConfig.paddingBottom ) / 16 + 'rem';
                curElement.style.paddingRight = (this.pageConfig.paddingRight ) / 16 + 'rem';
                curElement.style.paddingLeft = (this.pageConfig.paddingLeft ) / 16 + 'rem';
              })
              const ua = navigator.userAgent.toLowerCase();
              const isWeiXin = ua.indexOf("micromessenger") > -1;
              if (isWeiXin && this.pageConfig.weixinGuideBrowser) {
                this.showGuideBrowser = true;
              }
              // 尝试起调APP
              if (this.pageConfig.appPageScheme && this.pageConfig.appPageScheme.indexOf("hfqdl://") === 0) {
                window.location.href = this.pageConfig.appPageScheme;
              }
              // sensorsBuriedPoint('RecordPageViewTime', {
              //   Url: window.location.href,
              //   timeSpan: performance.now() - startTime,
              //   timeClassify: '接口请求完成到注册组件前'
              // }, false);
            } catch (error) {
              console.log('页面加载失败', error);
              sensorsBuriedPoint('PageView', {
                Url: window.location.href,
                errorClassify: '页面加载失败',
                userkey: getUrlParam("userKey") || "",
                errorReason: error.message || ''
              }, false);
            }
            this.registerComponents();
          })
        } catch (error) {
          console.log('页面加载失败', error);
          sensorsBuriedPoint('PageView', {
            Url: window.location.href,
            errorClassify: '页面加载失败',
            userkey: getUrlParam("userKey") || "",
            errorReason: error.message || ''
          }, false);
        }
      },
      registerComponents() {
        // 动态注册组件
        try {
          // const startTime = performance.now();
          this.pageComponents.forEach(item => {
            Vue.component(item.name, require(`../components/${item.name}.vue`).default);
          })
          this.timeSpan = performance.now() - this.timeSpan;
          console.log('页面加载时间', this.timeSpan);
          sensorsBuriedPoint('PageView', {
            Url: window.location.href,
            timeSpan: this.timeSpan,
            userkey: getUrlParam("userKey") || "",
          }, false);
          // sensorsBuriedPoint('RecordPageViewTime', {
          //   Url: window.location.href,
          //   timeSpan: performance.now() - startTime,
          //   timeClassify: '组件注册时间'
          // }, false);
        } catch (error) {
          console.log('动态注册组件失败', error);
          sensorsBuriedPoint('PageView', {
            Url: window.location.href,
            errorClassify: '动态注册组件失败',
            userkey: getUrlParam("userKey") || "",
            errorReason: error.message || ''
          }, false);
        }   
      },
    }
  }

</script>

<style scoped>
.form-box {
  padding-left: 15px;
  padding-top: 20px;
}
.popup-abs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.pupup-mask {
  position: fixed;
  z-index: 3;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5)
}
.popup-center {
  position: fixed;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
  background: #fff;
  padding: 20px;
  border-radius: 24px;
  color: #2e2e33;
}
.guide-box {
  text-align: center;
  padding-top: 34px;
}
.guide-img {
  width: 84px;
  height: 135px;
  margin-bottom: 12px;
}
.guide-text {
  font-size: 16px;
  color: #fff;
  font-family: PingFangSC-Medium, PingFang SC;
  letter-spacing: 2px;
  line-height: 34px;
  text-align: center;
}
</style>

